module.exports = __webpack_public_path__ + "img/branch-wuhan.e9358427.jpg";